var map = {
	"./account.mobile.svg": "lCda",
	"./account.svg": "GaiD",
	"./bookmark.mobile.svg": "GSti",
	"./bookmark.svg": "ZhXv",
	"./chip.svg": "fg8h",
	"./close.svg": "BXJ+",
	"./email.svg": "gPKQ",
	"./facebook.svg": "iwel",
	"./heart.mobile.svg": "qozl",
	"./heart.svg": "QOre",
	"./heartbroken.mobile.svg": "t3u4",
	"./heartbroken.svg": "Fzzk",
	"./heartfill.mobile.svg": "tTP8",
	"./heartfill.svg": "D5jE",
	"./instagram.svg": "B/vv",
	"./map.mobile.svg": "QWG2",
	"./map.svg": "3xkc",
	"./menu.svg": "OcSK",
	"./pinterest.svg": "hVRe",
	"./rss.svg": "MOdU",
	"./search.mobile.svg": "LNBf",
	"./search.svg": "+RmH",
	"./share.mobile.svg": "lWh2",
	"./share.svg": "QM8v",
	"./spinner.svg": "b7Sa",
	"./spinnerLarge.svg": "2jKv",
	"./twitter.svg": "l01v",
	"./vimeo.svg": "x0SP"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WYGR";